function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M218.74,254.21h35.68v7.03h-27.76v19.13h24.42v6.78h-24.42v26.24h-7.92v-59.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M278.68,272.27c12.42,0,21.67,9.15,21.67,21.01s-9.25,21.01-21.67,21.01-21.67-9.15-21.67-21.01,9.25-21.01,21.67-21.01Zm0,35.31c8.17,0,14.17-6.21,14.17-14.3s-6-14.3-14.17-14.3-14.17,6.21-14.17,14.3,6,14.3,14.17,14.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M308.28,273.17h7.5v5.89l.17,.08c2.83-3.92,7.34-6.29,12.17-6.29,.83,0,1.75,.08,2.67,.33v7.27c-1-.24-2-.33-2.92-.33-5.58,0-9.5,2.78-12.09,7.11v26.16h-7.5v-40.21Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M376.38,312.08c-1.92,1.23-5.67,2.21-9.25,2.21-4.17,0-8.09-1.31-10.67-4.01-2.17-2.29-3.58-5.64-3.58-12.01v-14.79h-6.67v-10.3h6.67v-10.46l12.67-2.13v12.59h10.84v10.3h-10.84v13.49c0,3.92,.92,6.87,4.75,6.87,2.08,0,4.42-.82,6.09-1.64v9.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M384.8,250.94h12.67v25.83l.17,.08c3-2.45,7.34-4.58,12.5-4.58,4.33,0,8.17,1.47,10.75,4.09,2.5,2.62,3.59,6.13,3.59,11.93v25.09h-12.67v-23.05c0-3.03-.42-4.5-1.42-5.64-1.08-1.23-2.58-1.72-4.33-1.72-3.25,0-6.34,1.64-8.59,3.35v27.05h-12.67v-62.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M445.24,296.55c1.42,5.56,6.09,8.09,11.92,8.09,4.58,0,9.59-1.55,13.92-4.41v10.38c-4,2.45-10.17,3.68-15.59,3.68-13.5,0-23.26-8.25-23.26-20.84s10.17-21.17,21.51-21.17c10.09,0,19.59,6.54,19.59,20.03,0,1.39-.08,3.19-.25,4.25h-27.84Zm16.42-7.85c-.75-4.33-4-6.95-8.09-6.95s-7.34,2.37-8.42,6.95h16.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M488.26,273.17h12.42v5.39l.17,.08c2.84-3.92,6.84-5.97,11.92-5.97,.83,0,1.75,.08,2.67,.33v11.69c-1-.24-2.25-.41-3.42-.41-4.42,0-8.08,1.31-11.09,4.74v24.36h-12.67v-40.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M531.78,296.55c1.42,5.56,6.08,8.09,11.92,8.09,4.59,0,9.59-1.55,13.92-4.41v10.38c-4,2.45-10.17,3.68-15.59,3.68-13.5,0-23.26-8.25-23.26-20.84s10.17-21.17,21.5-21.17c10.09,0,19.59,6.54,19.59,20.03,0,1.39-.08,3.19-.25,4.25h-27.84Zm16.42-7.85c-.75-4.33-4-6.95-8.08-6.95s-7.34,2.37-8.42,6.95h16.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M601.88,311.18c-3.92,2.13-8.75,3.11-13.42,3.11-13.17,0-22.84-8.83-22.84-20.92s10.67-21.09,23.5-21.09c4.59,0,8.84,1.06,12.17,2.7v11.52c-3.67-2.29-7.67-3.76-11.59-3.76-6.75,0-11.42,4.5-11.42,10.54s4.75,10.46,11.59,10.46c4,0,8.58-1.47,12-4.01v11.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M628.39,272.27c13.09,0,22.84,9.15,22.84,21.01s-9.75,21.01-22.84,21.01-22.84-9.15-22.84-21.01,9.75-21.01,22.84-21.01Zm0,31.31c5.75,0,10.17-4.58,10.17-10.3s-4.42-10.3-10.17-10.3-10.17,4.58-10.17,10.3,4.42,10.3,10.17,10.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M657.49,273.17h12.42v5.39l.17,.08c2.84-3.92,6.84-5.97,11.92-5.97,.83,0,1.75,.08,2.67,.33v11.69c-1-.24-2.25-.41-3.42-.41-4.42,0-8.08,1.31-11.09,4.74v24.36h-12.67v-40.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M718.01,311.18c-2.75,1.88-6.42,3.11-10.42,3.11-10.33,0-19.25-7.85-19.25-20.19s9.42-21.82,21.67-21.82c3.08,0,5.59,.57,7.75,1.47l.17-.08v-22.72h12.67v62.45h-12.42v-2.12l-.17-.08Zm-.08-27.05c-1.83-.9-4.09-1.55-6.58-1.55-6.67,0-10.25,4.9-10.25,10.95s3.5,10.63,9.75,10.63c2.75,0,5.25-.9,7.08-2.04v-17.98Z"
}));

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "b",
  points: "110.23 215.01 110.23 313.39 130.25 313.39 130.25 234.07 187.64 234.07 187.64 215.01 110.23 215.01"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "b",
  points: "154.21 288.28 135.4 270.7 145.9 259.48 154.84 267.84 177.86 248.86 187.63 260.72 154.21 288.28"
});

var SvgSafetyWiseLogoWhite = function SvgSafetyWiseLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 841.89 595.28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSafetyWiseLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/safety-wise-logo-white.8f2f6e93.svg";
export { ForwardRef as ReactComponent };